<template>
  <div class="d-inline-block font-size-sm position-relative">
    <span class="text-right d-inline-block">
      <strong>{{user.firstName}} {{user.lastName}}</strong><br>
      {{user.email}}
    </span>
    <a
      style="vertical-align: top;"
      class="text-secondary cursor-pointer ml-3"
      v-on:click="handleLogout"
    >Sign Out</a>
  </div>
</template>

<script>
import oauth from '../auth0'

export default {
  props: {
    user: Object
  },
  methods: {
    handleLogout (event) {
      event.preventDefault()
      oauth.logout({
        returnTo: process.env.VUE_APP_AUTH0_REDIRECT_URI
      })
    }
  }
}
</script>
